import React, { useState, useEffect } from "react";
import DashboardHeader from "../../Header/DashboardHeader";
import DashboardFooter from "../../Footer/DashboardFooter";
import DashboardLeftMenu from "../DashboardLeftMenu";
import Axios from "axios";
import { NODE_HOST_URL_v1 } from "../api/Api";

const MyPlans = () => {
  const lStorage = JSON.parse(localStorage.getItem("login"));
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;

  const countryCurrency = lStorage?.user?.country_currency || "USD";
  const CURRENCY_CONFIG = {
    INR: { symbol: "₹", key: "amount_inr" },
    USD: { symbol: "$", key: "amount_usd" },
    EUR: { symbol: "€", key: "amount_eur" },
  };
  const currency = CURRENCY_CONFIG[countryCurrency] || CURRENCY_CONFIG.USD;

  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchUserActivePlans();
  }, []);

  const fetchUserActivePlans = async () => {
    setLoading(true);
    try {
      const response = await Axios.post(`${NODE_HOST_URL_v1}/plans`, {
        method: "fetchUserEnabledPlans",
        user_id: userId,
        token: userToken,
      });
      if (response.data.success === true) {
        setPlans(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching user plans:", error);
    }
    setLoading(false);
  };

  return (
    <div className="wrapper">
      <DashboardLeftMenu />
      <div className="main">
        <DashboardHeader />
        <main className="content">
          <div className="container-fluid p-0">
            <div style={styles.page}>

              {/* Header */}
              <div style={styles.pageHeader}>
                <div>
                  <h4 style={styles.pageTitle}>My Plans</h4>
                  <p style={styles.pageSub}>All active and expired plans on your account.</p>
                </div>
                <span style={styles.countBadge}>{plans.length} plan{plans.length !== 1 ? "s" : ""}</span>
              </div>

              {/* Table card */}
              <div style={styles.card}>
                {loading ? (
                  <div style={styles.emptyState}>
                    <div style={styles.spinner} />
                    <p style={styles.emptyText}>Loading your plans…</p>
                  </div>
                ) : plans.length === 0 ? (
                  <div style={styles.emptyState}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#d1d5db" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginBottom: 12 }}>
                      <rect x="2" y="7" width="20" height="14" rx="2" />
                      <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
                    </svg>
                    <p style={styles.emptyText}>You don't have any plans yet.</p>
                  </div>
                ) : (
                  <div style={styles.tableWrap}>
                    <table style={styles.table}>
                      <thead>
                        <tr>
                          <th style={styles.th}>#</th>
                          <th style={styles.th}>Plan Name</th>
                          <th style={styles.th}>Type</th>
                          <th style={styles.th}>For</th>
                          <th style={styles.th}>Duration</th>
                          <th style={styles.th}>Amount</th>
                          <th style={styles.th}>Start Date</th>
                          <th style={styles.th}>End Date</th>
                          <th style={styles.th}>Auto Renew</th>
                          <th style={styles.th}>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {plans.map((plan, i) => (
                          <tr key={plan.id ?? i} style={styles.tr}>
                            <td style={styles.tdMuted}>{i + 1}</td>
                            <td style={styles.tdBold}>{plan.plan_title || "—"}</td>
                            <td style={styles.td}>{plan.plan_type || "—"}</td>
                            <td style={styles.td}>{plan.plan_for || "—"}</td>
                            <td style={styles.td}>{plan.plan_duration || "—"}</td>
                            <td style={styles.td}>
                              {plan[currency.key] != null
                                ? `${currency.symbol}${plan[currency.key]}`
                                : "—"}
                            </td>
                            <td style={styles.td}>{plan.startDate ? plan.startDate.slice(0, 10) : "—"}</td>
                            <td style={styles.td}>{plan.endDate ? plan.endDate.slice(0, 10) : "—"}</td>
                            <td style={styles.td}>
                              <span style={plan.auto_renew ? styles.badgeGreen : styles.badgeGray}>
                                {plan.auto_renew ? "Yes" : "No"}
                              </span>
                            </td>
                            <td style={styles.td}>
                              {plan.is_expired
                                ? <span style={styles.badgeRed}>Expired</span>
                                : <span style={styles.badgeGreen}>Active</span>
                              }
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>

            </div>
          </div>
        </main>
        <DashboardFooter />
      </div>
    </div>
  );
};

const styles = {
  page: {
    padding: "24px 24px 40px",
    background: "#f9fbff",
    minHeight: "100vh",
  },
  pageHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: 12,
    marginBottom: 20,
  },
  pageTitle: {
    fontSize: "1.15rem",
    fontWeight: 700,
    color: "#111827",
    margin: 0,
  },
  pageSub: {
    fontSize: "0.8rem",
    color: "#9ca3af",
    margin: "3px 0 0",
  },
  countBadge: {
    background: "#eef2ff",
    color: "#6366f1",
    fontSize: "0.72rem",
    fontWeight: 700,
    padding: "4px 12px",
    borderRadius: 20,
    alignSelf: "center",
  },
  card: {
    background: "#fff",
    borderRadius: 14,
    border: "1px solid #e9eaf0",
    boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
    overflow: "hidden",
  },
  tableWrap: {
    overflowX: "auto",
    WebkitOverflowScrolling: "touch",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "0.82rem",
    minWidth: 620,
  },
  th: {
    padding: "12px 16px",
    textAlign: "left",
    fontSize: "0.68rem",
    fontWeight: 700,
    letterSpacing: "0.6px",
    textTransform: "uppercase",
    color: "#9ca3af",
    background: "#f9fafb",
    borderBottom: "1px solid #f3f4f6",
    whiteSpace: "nowrap",
  },
  tr: {
    borderBottom: "1px solid #f9fafb",
    transition: "background 0.12s",
  },
  td: {
    padding: "13px 16px",
    color: "#374151",
    verticalAlign: "middle",
  },
  tdBold: {
    padding: "13px 16px",
    color: "#111827",
    fontWeight: 600,
    verticalAlign: "middle",
  },
  tdMuted: {
    padding: "13px 16px",
    color: "#9ca3af",
    verticalAlign: "middle",
  },
  badgeGreen: {
    display: "inline-block",
    background: "#f0fdf4",
    color: "#16a34a",
    fontSize: "0.7rem",
    fontWeight: 700,
    padding: "3px 10px",
    borderRadius: 20,
    border: "1px solid #bbf7d0",
  },
  badgeRed: {
    display: "inline-block",
    background: "#fff1f2",
    color: "#e11d48",
    fontSize: "0.7rem",
    fontWeight: 700,
    padding: "3px 10px",
    borderRadius: 20,
    border: "1px solid #fecdd3",
  },
  badgeGray: {
    display: "inline-block",
    background: "#f9fafb",
    color: "#9ca3af",
    fontSize: "0.7rem",
    fontWeight: 700,
    padding: "3px 10px",
    borderRadius: 20,
    border: "1px solid #e5e7eb",
  },
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "56px 24px",
  },
  emptyText: {
    color: "#9ca3af",
    fontSize: "0.88rem",
    margin: 0,
  },
  spinner: {
    width: 32,
    height: 32,
    border: "3px solid #e5e7eb",
    borderTop: "3px solid #6366f1",
    borderRadius: "50%",
    animation: "spin 0.7s linear infinite",
    marginBottom: 12,
  },
};

export default MyPlans;
